module.exports = "<div class=welcome>\n  <logo class=\"\"></logo>\n  <div class=\"installation-title welcome__text\" translate>\n    <a href=install/base class=ring-link anchor-id=setupLink>Set up</a> or\n    <a href=upgrade/source class=ring-link anchor-id=upgradeLink>Upgrade</a>\n    to&nbsp;<span class=welcome__installation-name>{{ctrl.getInstallationTitle()}}</span>\n  </div>\n  <div translate>\n    You can restore on Upgrade page\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/pages/welcome/welcome.html
// module id = 829
// module chunks = 0